class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.currentVariant = document.querySelector(".product-variant-id").value;
    this.attributeChangedCallback();
    this.displaySubscriptionWidget(this.currentVariant);
    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChangeInitiated,
      (event) => {
        document.querySelector(".rc-container-wrapper")
          ? document.querySelector(".rc-container-wrapper").remove()
          : "";
        this.setSellingPlanValue("");
        const currentVariant = event.data.variant;
        // console.log(currentVariant);
        this.displaySubscriptionWidget(currentVariant.id);
        this.triggerSubscriptionOption(currentVariant.id);
      }
    );
  }
  variantChangeUnsubscriber = undefined;

  displaySubscriptionWidget(variantId) {
    // Reset selling plan value
    this.setSellingPlanValue("");

    // Hide all subscription widgets
    this.hideAllSubscriptionWidgets();

    // Show the subscription widget for the specified variant
    this.showSubscriptionWidget(variantId);

    // Trigger click on the subscription option
    this.triggerSubscriptionOption(variantId);
  }

  setSellingPlanValue(value) {
    setTimeout(() => {
      if (document.querySelector('[name="selling_plan"][type="hidden"]')) {
        document.querySelector('[name="selling_plan"][type="hidden"]').value =
          value;
      }
    }, 500);
  }

  hideAllSubscriptionWidgets() {
    this.querySelectorAll(".subscription-widget").forEach((el) => {
      el.classList.add("hide-subscription-widget");
    });
  }

  showSubscriptionWidget(variantId) {
    this.querySelector(`#subscription-widget-${variantId}`).classList.remove(
      "hide-subscription-widget"
    );
  }

  triggerSubscriptionOption(variantId) {
    if (
      this.querySelector(
        `[name="purchaseOption_${variantId}"][value="subscription"]`
      )
    ) {
      this.querySelector(
        `[name="purchaseOption_${variantId}"][value="subscription"]`
      ).click();
    }
  }

  connectedCallback() {
    // Called when the element is connected to the DOM
    // TODO: Implement this method
    window.addEventListener("load", () => {
      // console.log("window loaded event started");
      this.checkRechargeLoaded = setInterval(() => {
        if (
          !document.querySelector("body").querySelector(".rc-container-wrapper")
        ) {
          return false;
        }
        clearInterval(this.checkRechargeLoaded);
        // console.log("window loaded");
        // this.displaySubscriptionWidget(this.currentVariant);
        // this.triggerSubscriptionOption(this.currentVariant);
      }, 200);

      // this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChangeInitiated, (event) => {
      //     document.querySelector('.rc-container-wrapper') ? document.querySelector('.rc-container-wrapper').remove() : '';
      //     this.setSellingPlanValue('');
      //     const currentVariant = event.data.variant;
      //     // console.log(currentVariant);
      //     this.displaySubscriptionWidget(currentVariant.id);
      //     this.triggerSubscriptionOption(currentVariant.id);
      // });
    });
  }

  disconnectedCallback() {
    // Called when the element is disconnected from the DOM
    // TODO: Implement this method
  }

  attributeChangedCallback() {
    this.querySelectorAll('[name*="purchaseOption"]').forEach((option) => {
      option.addEventListener("click", () => {
        this.querySelector(".rc-container-wrapper")
          ? this.querySelector(".rc-container-wrapper").remove()
          : "";

        this.querySelectorAll('[name*="purchaseOption"]').forEach((el) => {
          el.closest(".subscription-input-label").classList.remove("active");
        });
        option.closest(".subscription-input-label").classList.add("active");
        this.setSellingPlanValue(option.getAttribute("data-selling-plan"));

        /* subscription price update fix start*/

        document
          .querySelectorAll(".price-item--regular .price-item-actual")
          .forEach((el) => {
            if (option.getAttribute("data-selling-compare-at-price")) {
              el.innerHTML = `${option.getAttribute(
                "data-selling-compare-at-price"
              )}`;
            } else {
              el.innerHTML = `${option.getAttribute("data-selling-price")}`;
            }
          });
        document
          .querySelectorAll(".price-item--sale .price-item-actual")
          .forEach((el) => {
            el.innerHTML = `${option.getAttribute("data-selling-price")}`;
          });

        document
          .querySelectorAll(".price-item--regular .price-item__quantifier")
          .forEach((el) => {
            el.innerHTML = `${option.getAttribute("data-selling-unit-price")}`;
          });
        document
          .querySelectorAll(".price-item--sale .price-item__quantifier")
          .forEach((el) => {
            el.innerHTML = `${option.getAttribute("data-selling-unit-price")}`;
          });

        /* subscription price update fix end*/
      });
    });
  }
}

// Instantiate the custom element
// const customElement = new SubscriptionWidget();

customElements.define("subscription-widget", SubscriptionWidget);
